export var DEFAULT_TITLE_SORT = {
    sortBy: "name",
    sortDir: "ASC",
};
export var TITLE_SORT_STORAGE_PREFIX = "pvTitleSort.";
export var toMclSortDirection = function (dir) { return (dir === "DESC" ? "descending" : "ascending"); };
export var columnSortKeys = function (columns) {
    return columns
        .map(function (column) { return column.sortKey; })
        .filter(function (sortKey) { return !!sortKey; });
};
/**
 * The backend rejects a sort key the list does not offer with 400, so a stored or
 * otherwise stale state must never leave the client unless the table offers that key.
 */
export var resolveTitleSort = function (candidate, allowedKeys, fallback) {
    if (!candidate || typeof candidate !== "object") {
        return fallback;
    }
    var _a = candidate, sortBy = _a.sortBy, sortDir = _a.sortDir;
    if (typeof sortBy !== "string" ||
        !allowedKeys.includes(sortBy) ||
        (sortDir !== "ASC" && sortDir !== "DESC")) {
        return fallback;
    }
    return { sortBy: sortBy, sortDir: sortDir };
};
export var parseStoredTitleSort = function (raw, allowedKeys, fallback) {
    if (!raw) {
        return fallback;
    }
    try {
        return resolveTitleSort(JSON.parse(raw), allowedKeys, fallback);
    }
    catch (_a) {
        return fallback;
    }
};
export var nextTitleSort = function (current, sortBy) {
    return current.sortBy === sortBy
        ? { sortBy: sortBy, sortDir: current.sortDir === "ASC" ? "DESC" : "ASC" }
        : { sortBy: sortBy, sortDir: "ASC" };
};
